export default "__VITE_ASSET__7fc111e8__"